import app from "../_app";

const outofstock = document.querySelector('.js-outofstock');
const outofstockTriggers = [...document.querySelectorAll('.js-outofstock-trigger')];

export const openOutofstockHandler = (product) => {
    if(outofstock) {
        app.lockBody();
        outofstock.setAttribute('data-open', '');
        outofstock.setAttribute('variant', product.dataset.variant);
        outofstock.setAttribute('variantid', product.dataset.variantid);
        outofstock.querySelector('.js-outofstock-title').innerHTML = product.dataset.title;
    }
};

if(outofstock) {
    const closeTriggers = [...outofstock.querySelectorAll('.js-outofstock-close')];

    const closeOutofstockHandler = () => {

        outofstock.removeAttribute('data-open');
        [...outofstock.querySelector('.js-outofstock-content').querySelectorAll('div')].map(element => {
            element.classList.remove('d-block');
        });
        app.unlockBody();
    };

    closeTriggers.map(closeTrigger => closeTrigger.addEventListener('click', closeOutofstockHandler));
}

outofstockTriggers.map(outofstockTrigger => outofstockTrigger.addEventListener('click', () => { openOutofstockHandler(outofstockTrigger) }));
